/**
 * Returns an HTML string representing a single material block.
 * 
 * @param material The individual material data json
 */
export function materialTemplate(material: MaterialsItem): string {
    return `
        <div class="o-layout__item u-6/12@tablet u-4/12@desktop u-3/12@wide js-materials__item">
            <div class="c-overlay-box ${ material.data.material_type_class } js-overlay-box js-fade-slide-up__item">
                <a href="${ material.data.material_permalink }" class="c-overlay-box__content js-overlay-box__content">
                    <div class="c-overlay-box__inner js-overlay-box__inner">
                        <div class="c-overlay-box__sizer js-overlay-box__sizer">
                            <h2 class="c-overlay-box__title">${ material.data.material_title }</h2>
                        </div>
                        <div class="c-overlay-box__logo-container"><svg class="c-overlay-box__logo-mark" width="91" height="150"><use xlink:href="#svg-logo-mark-alt"></use></svg></div>
                    </div>
                </a>
                <img class="o-bg u-fill c-overlay-box__bg" src="${ material.data.material_image.src }" alt="${ material.data.material_image.alt }" srcset="${ material.data.material_image.srcset }" sizes="(max-width: 740px) 100vw, (max-width: 980px) 50vw, 25vw" />
            </div>
        </div>
    `;
}


/**
 * Returns an HTML string representing a single material type block.
 * 
 * @param materialType The individual material type data json
 */
export function materialTypeTemplate(materialType: MaterialsTypeItem): string {
    return `
    <div class="o-layout__item u-6/12@tablet u-4/12@desktop u-3/12@wide js-materials__item">
        <div class="c-material-type-block ${ materialType.data.class } js-fade-slide-up__item">
            <a href="${ materialType.data.link }" class="js-content-loader__replace c-material-type-block__link js-materials__update-type" data-value="${ materialType.data.term_value }">
                <div class="u-12/12">
                    <p class="c-material-type-block__cta">${ materialType.data.cta }</p>
                    <p class="c-material-type-block__logo"><img loading="lazy" src="${ materialType.data.image.src }" alt="${ materialType.data.image.alt }"></p>
                </div>
            </a>
        </div>
    </div>
    `;
}
